import type { FC, PropsWithChildren } from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { isEmptyOrNull } from '@/shared/utils/string';

const styles = StyleSheet.create({
  container: { gap: 16 },
  label: { fontWeight: 600, marginBottom: -8 }
});

type Props = {
  label?: string;
  style?: ViewStyle;
} & PropsWithChildren;

export const FormGroup: FC<Props> = ({ label, style, children }) => (
  <View style={[styles.container, style]}>
    {!isEmptyOrNull(label) && (
      <Text variant="labelLarge" style={styles.label}>
        {label}
      </Text>
    )}
    {children}
  </View>
);
